export default __webpack_public_path__ + "static/media/15.81f66f48.jpg";